"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_export_client_js_1 = require("@synisys/idm-export-client-js");
function extensionToExportType(extension) {
    switch (extension) {
        case 'PDF':
            return idm_export_client_js_1.ExportType.PDF;
        case 'RTF':
        case 'DOCX':
            return idm_export_client_js_1.ExportType.DOCX;
        case 'XLS':
            return idm_export_client_js_1.ExportType.EXCEL;
    }
    throw new Error("Unsupported extension type: " + extension);
}
exports.extensionToExportType = extensionToExportType;
function exportTypeToExtension(exportType) {
    switch (exportType) {
        case idm_export_client_js_1.ExportType.PDF:
            return 'PDF';
        case idm_export_client_js_1.ExportType.RTF:
        case idm_export_client_js_1.ExportType.DOCX:
            return 'DOCX';
        case idm_export_client_js_1.ExportType.EXCEL:
            return 'XLS';
    }
    throw new Error("Unsupported extension type: " + exportType);
}
exports.exportTypeToExtension = exportTypeToExtension;
function formTemplateFromPersonalized(template) {
    return {
        id: template.uuid,
        name: template.name,
        extension: exportTypeToExtension(template.exportType),
        isPersonalized: true,
    };
}
exports.formTemplateFromPersonalized = formTemplateFromPersonalized;
function previewDocument(blob) {
    var fileURL = URL.createObjectURL(blob);
    if (is_safari(window)) {
        location.href = fileURL;
    }
    else {
        window.open(fileURL);
    }
    setTimeout(function () {
        URL.revokeObjectURL(fileURL);
    }, 1);
}
exports.previewDocument = previewDocument;
function is_safari(view) {
    return /constructor/i.test(view.HTMLElement) || view.safari;
}
exports.is_safari = is_safari;
//# sourceMappingURL=template.utilities.js.map